import { Navigate } from 'react-router-dom';
import { getStoredToken, isTokenValid, hasOrgAccess } from '../auth/cognito';
import { ReactElement } from 'react';

export default function ProtectedRoute({ children }: { children: ReactElement }) {
  const token = getStoredToken();
  if (!token || !isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }
  if (!hasOrgAccess()) {
    return <Navigate to="/no-access" replace />;
  }
  return children;
}